import moment from "moment";

const formatDateWithoutTime = (date: any, short = false) => {
  const dateFormat = short
    ? moment(date).format("DD MMM YYYY")
    : moment(date).format("DD MMMM YYYY");
  return date ? dateFormat : "-";
};
export default formatDateWithoutTime;
